import { Checkbox } from '@material-ui/core';
import React, { FC, memo, useCallback, useMemo } from 'react';

export type CheckboxState = 'checked' | 'intermediate' | 'unchecked';

const noop = () => undefined;

interface Props {
  checked?: boolean;
  state?: CheckboxState;
  color?: 'primary' | 'secondary' | 'default';
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export const MuiCheckbox: FC<Props> = memo(
  ({ checked, state, disabled, color, onChange = noop }: Readonly<Props>) => {
    const stateMerged = useMemo<CheckboxState>(
      () =>
        (checked === undefined ? state : checked ? 'checked' : 'unchecked') ??
        'unchecked',
      [checked, state]
    );

    const onChangeHandler = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
      },
      [onChange]
    );

    return (
      <Checkbox
        disabled={disabled}
        color={color}
        checked={stateMerged === 'checked'}
        indeterminate={stateMerged === 'intermediate'}
        onChange={onChangeHandler}
      />
    );
  }
);

MuiCheckbox.displayName = 'MuiCheckbox';
